"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./directive"));
__export(require("./validator"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng2-validation/dist/uuid/index.js
// module id = ../../../../ng2-validation/dist/uuid/index.js
// module chunks = 7